export const APIProviderConsent = {
  TERMS_ACCEPTED: 'ENABLED',
  TERMS_REJECTED: 'REJECTED',
  TERMS_REVOKED: 'DISABLED',
  NO_TERMS_EXIST: '',
  TERMS_NOT_ACCEPTED: ''
};
